module.exports = __webpack_public_path__ + "img/page-left.3714459d.jpg";